import React, { useState, useEffect } from "react";
import { Grid, Modal, Typography, Button, Box } from "@mui/material";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Grid as DataGrid, GridColumn } from "@progress/kendo-react-grid";
import EditButtonCell from "../edit-button-cell";
import { useDispatch, useSelector } from "react-redux";
import { orderBy } from "@progress/kendo-data-query";
import { useHistory } from "react-router-dom";
import { USER_FINANCIALPROFESSIONAL, USER_SUPERADMIN, USER_CONCIERGE, USER_CASEDESIGNER, ACTION_SET_FINANCIAL_PROFESSIONAL } from "../../shared/constants";
import {
  getSuperAdminClientList,
  deleteClient
} from "../../shared/api";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import DeleteButtonCell from "../delete-button-cell";

const ClientList = (props) => {
  const { idIncomeUser } = useParams();
  const [state, setState] = useState({
    currentProfessional: {
      name: props.selectedUser
        ? `${props.selectedUser.firstName} ${props.selectedUser.lastName}`
        : "",
      value: props.selectedUser ?
        props.selectedUser.id : idIncomeUser !== undefined ?
          idIncomeUser : null,
    },
    sort: [
      {
        field: "lastUpdateDateVal",
        dir: "desc",
      },
    ],
    page: { skip: 0, take: 10 },
    clientList: [],
    ButtonAddPlan: true,
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const history = useHistory();

  const dispatch = useDispatch();

  const authorization = useSelector((state) =>
    state.dataStore.getIn(["currentUser", "authorization"])
  );

  const authToken = useSelector((state) =>
    state.dataStore.getIn(["loginInfo", "authorizationToken"])
  );

  const email = useSelector(state =>
    state.dataStore.getIn(['loginInfo', 'userName'])
  );

  const ifwUsers = useSelector(state =>
    state.dataStore.getIn(["ifwUsers"])
  );

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  useEffect(() => {
    if (state.currentProfessional.value === null) return;

    const currentFinancialProfessional =
      authorization === USER_FINANCIALPROFESSIONAL ?
        {
          firstName: '',
          lastName: '',
          id: state.currentProfessional.value,
          email: email
        }
        :
        ifwUsers
          .toJS()
          .find(professional =>
            professional.id == state.currentProfessional.value
          );

    props.setSelectedUser(state => {
      return {
        ...state,
        selectedUser: {
          id: currentFinancialProfessional.id,
          firstName: currentFinancialProfessional.firstName,
          lastName: currentFinancialProfessional.lastName,
        }
      }
    });

    dispatch({
      type: ACTION_SET_FINANCIAL_PROFESSIONAL,
      value: {
        firstName: currentFinancialProfessional?.firstName,
        lastName: currentFinancialProfessional?.lastName,
        advisorId: currentFinancialProfessional?.id,
        email: currentFinancialProfessional?.email
      }
    })

    getSuperAdminClientList(state.currentProfessional.value, authToken)
      .then(response => {
        setState({
          ...state,
          currentProfessional: {
            name: `${currentFinancialProfessional.firstName} ${currentFinancialProfessional.lastName}`,
            value: state.currentProfessional.value
          },
          clientList: response.map((plan) => {
            return {
              ...plan,
              status: plan.status.includes("Published") ? "Published" : plan.status,
              createDateVal: new Date(plan.createDate),
              lastUpdateDateVal: new Date(plan.lastUpdateDate),
            }
          }),
        });
      })
      .catch(e => console.log('something went wrong when populate user client list', e))

  }, [state.currentProfessional.value]);


  const filterFp = (item) => item.role === USER_FINANCIALPROFESSIONAL

  const filterFPConcierge = (item) => props.fpBindingConcierge.includes(item.clientId)

  const filterIdFP = (item) => item.id === props.advisorId

  const financialProData = ifwUsers
    .toJS()
    .filter(
      authorization === USER_SUPERADMIN || authorization === USER_CASEDESIGNER ?
        filterFp : authorization === USER_CONCIERGE ? filterFPConcierge : filterIdFP)
    .map((item) => {
      return {
        name: `${item.firstName} ${item.lastName}`,
        value: item.id,
      };
    });

  const edit = (dataItem) => {
    history.push(
      `/financial-professionals/${state.currentProfessional.value}/clients/${dataItem.clientId}/plan-inputs`
    );
  };

  const deleteFn = (dataItem) => {
    setItemToDelete(dataItem);
    setShowDeleteModal(true);
  };

  const finishDelete = () => {

    deleteClient(itemToDelete.clientId, authToken)
        .then((response) => {

          const newClientList = state.clientList.filter(item => {
            return item.clientId !== itemToDelete.clientId;
          });

          setState({
            ...state,
            clientList: newClientList
          });
          setShowDeleteModal(false);
          setItemToDelete(null);
        });
  }

  let deleteModal = null;
  if (showDeleteModal) {
    deleteModal =
      <Modal
          open={true}
          onClose={() => {
            setShowDeleteModal(false);
            setItemToDelete(null);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle} className={"delete-client-modal"}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography component={"label"} variant={"label"}>
              Are you sure you want to delete the client? You will lose all the client data and plans permanently?
            </Typography>
          </Grid>
          <Grid className={"delete-client-ctrls"} item xs={12}>
            <Button onClick={() => {
              setShowDeleteModal(false);
              setItemToDelete(null);
            }}>Cancel</Button>
            <Button onClick={() => {
              finishDelete();
            }}>Yes</Button>
           </Grid>
        </Grid>
        </Box>
    </Modal>
  }

  return (
      <>
        <Grid container>
          <Grid
            container
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            mb={3}
          >
            <Grid item xs={8} ml={2}>
              {authorization !== USER_FINANCIALPROFESSIONAL && (
                <DropDownList
                  style={{ width: '290px' }}
                  data={financialProData}
                  label={"Financial Professional"}
                  dataItemKey={"value"}
                  textField={"name"}
                  value={state.currentProfessional}
                  onChange={(e) => {
                    setState({
                      ...state,
                      currentProfessional: e.value,
                      ButtonAddPlan: false,
                    });
                  }}
                />
              )}
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <DataGrid
              scrollable={"none"}
              className={"ifw-datagrid"}
              sort={state.sort}
              data={orderBy(state.clientList, state.sort).slice(
                state.page.skip,
                state.page.take + state.page.skip
              )}
              sortable={true}
              onSortChange={(e) => {
                setState({
                  ...state,
                  sort: e.sort,
                });
              }}
              skip={state.page.skip}
              take={state.page.take}
              total={state.clientList.length}
              pageable={true}
              onPageChange={(event) => {
                setState({
                  ...state,
                  page: event.page,
                });
              }}
              onRowClick={(event) => {
                const dataItem = event.dataItem;
                history.push(
                  `/financial-professionals/${state.currentProfessional.value}/clients/${dataItem.clientId}/plan-inputs`
                );
              }}
            >
              <GridColumn title={"First Name"} field={"firstName"} />
              <GridColumn title={"Last Name"} field={"lastName"} />
              <GridColumn title={"Status"} field={"status"} />
              <GridColumn
                title={"Create Date"}
                field={"createDateVal"}
                format="{0:MM/dd/yyyy}"
              />
              <GridColumn
                title={"Last Update"}
                field={"lastUpdateDateVal"}
                format="{0:MM/dd/yyyy}"
              />
              <GridColumn title={" "} cell={EditButtonCell(edit)} />
              {(authorization === USER_FINANCIALPROFESSIONAL || authorization === USER_SUPERADMIN) && <GridColumn
               title={" "}
               cell={DeleteButtonCell(deleteFn)}
              />}
            </DataGrid>
          </Grid>
          {deleteModal}
        </Grid>

      </>
  );
};

export default ClientList;
